/*----------------------------------
- SEARCH WORKFLOW MOTION
- Decorative fake-data preview of the product prompt over its filter breadth.
----------------------------------*/

import Icon from '@/client/components/ui/icon/Icon';

/*----------------------------------
- CONTENT
----------------------------------*/

const FILTER_ROWS = [
    ['Price under $25k', '.com + .ai', 'One word', 'Available now', 'Clean history'],
    ['High demand', 'Positive sentiment', 'Brandable', 'Renewal under $100', 'No hyphens'],
    ['Low trademark risk', 'Search demand', 'Short length', 'English words', 'Registrar listed'],
] as const;

/*----------------------------------
- COMPONENT
----------------------------------*/

const SearchWorkflowMotion = () => (
    <div aria-hidden="true" class="ud-workflow-search">
        <div class="ud-workflow-search__rails">
            {FILTER_ROWS.map((filters, rowIndex) => (
                <div
                    key={filters[0]}
                    class={`ud-workflow-search__rail ${rowIndex % 2 === 1 ? 'ud-workflow-search__rail--reverse' : ''}`}
                >
                    <div class="ud-workflow-search__rail-track">
                        {[...filters, ...filters].map((filter, filterIndex) => (
                            <span key={`${filter}-${filterIndex}`} class="ud-workflow-search__chip">
                                {filter}
                            </span>
                        ))}
                    </div>
                </div>
            ))}
        </div>

        <div class="ud-workflow-search__prompt">
            <span class="ud-workflow-search__prompt-icon">
                <Icon name="plus" size={14} strokeWidth={2.2} />
            </span>
            <span class="ud-workflow-search__prompt-copy">One-word AI infra brands with clean history</span>
        </div>
    </div>
);

export default SearchWorkflowMotion;
